import styled, { keyframes } from 'styled-components'

type SpinnerStyledProps = {
  background: string
  position: string
}

export const SpinnerStyled = styled('div')<SpinnerStyledProps>`
  height: calc(100% + 50px);
  width: calc(100% + 50px);
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ background }) => background || '#434343'};
  position: ${({ position }) => position || 'static'};

  backdrop-filter: ${({ background }) =>
    background === 'transparent' ? 'blur(3px)' : 'unset'};
  z-index: 6;
  left: 0;
  margin: -25px;
  padding: 0 100px;
`

// const heartbeat = keyframes`
//   0%
//   {
//     transform: scale( .8 );
//   }
//   15%
//   {
//     transform: scale( .9 );
//   }
//   25%
//   {
//     transform: scale( .8 );
//   }
//   35%
//   {
//     transform: scale( 1 );
//   }
//   45%
//   {
//     transform: scale( .9 );
//   }
//   55%
//   {
//     transform: scale( 1 );
//   }
//   65%
//   {
//     transform: scale( .8 );
//   }
//   100%
//   {
//     transform: scale( .8 );
//   }
// `

// export const SpinnerImage = styled.img`
//   height: auto;
//   width: 100%;
//   max-width: 40vw;
//   animation: ${heartbeat} 1s infinite;
//   backdrop-filter: blur(3px);
// `
